import { Fragment, useEffect, useRef, useState } from 'react'
import './login.css'
import { useFormik } from 'formik'
import { useIsMobile } from '../../../../utils/hooks/useIsMobile'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as AuthService from '../../../../services/auth'
import { Modal } from 'react-bootstrap'
import Agreement from './Agreement'
import ReCAPTCHA from 'react-google-recaptcha'

export function Activation() {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null)
  const [loading, setLoading] = useState(false)
  const isMobile = useIsMobile()
  const [show, setShow] = useState<any>(false)
  const [agree, setAgree] = useState<any>(false)
  const [initialValues, setInitialValues] = useState({
    email: '',
    id_card: '',
    agreement: false,
    g_recaptcha_response: '',
  })

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      agreement: agree,
    })
  }, [agree])

  const toggle = () => setShow(!show)

  const agreement = (agree: boolean) => {
    setAgree(agree)
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)

      if (!agree) {
        toast.error('Syarat dan ketentuan harus disetujui')
        setLoading(false)
        return
      }

      try {
        await AuthService.requestActivation({ email: values.email, id_card: values.id_card, g_recaptcha_response: values.g_recaptcha_response })
        toast('Berhasil Requst Aktivasi, silahkan tunggu konfirmasi selanjutnya lewat email')
        setLoading(false)
      } catch (error: any) {
        toast?.error?.(error?.message)
        toast?.error?.(error?.error?.message)
        setSubmitting(false)
        setLoading(false)
        setStatus('The login details are incorrect')
      }
    },
  })

  return (
    <Fragment>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title> Syarat dan Ketentuan Layanan </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Agreement toggle={toggle} agreement={agreement} />
        </Modal.Body>
      </Modal>

      <Fragment>
        <div className='d-flex flex-column flex-md-row'>
          <div
            className='side-one bg-image'
            style={{
              backgroundImage: `url(${require('../../../../assets/img/bg-alumni.png')})`,
            }}
          >
            <div className='image-small'>
              <img src={require('../../../../assets/img/bg-alumni.png')} />
            </div>
          </div>
          <div className='side-two'>
            <div className='form-container'>
              <img
                src={require('../../../../assets/img/login-logo.png')}
                alt=''
                className='login-logo'
              />
              <p className='fontsize-42 fontweight-600 mt-5 mb-8'>Aktivasi Akun</p>

              <form className='input-container' onSubmit={formik.handleSubmit}>
                <label className='input-label'>Email</label>
                <input type='email' {...formik.getFieldProps('email')} className='input-form' />

                <label className='input-label'>NIK (No. KTP)</label>
                <div className='input-icons'>
                  <input type='text' className='input-form' {...formik.getFieldProps('id_card')} />
                </div>


                <div className='mb-10'>
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey='6Lf3qh8qAAAAAAmCYQOBXog8koATjbM4w7HZBGo2'
                    onChange={(value) => formik.setFieldValue('g_recaptcha_response', value)}
                    onExpired={() => {
                      formik.setFieldValue('g_recaptcha_response', '')
                      toast.error('Captcha expired, silakan centang ulang.')
                    }}
                  />

                  {formik.touched.g_recaptcha_response && formik.errors.g_recaptcha_response && (
                    <div className='text-danger small mt-1'>{formik.errors.g_recaptcha_response}</div>
                  )}
                </div>
                <div className='space-between mb-30' style={{ maxWidth: '500px' }}>
                  <input style={{ zoom: '1.3' }} type='checkbox' checked={agree} onChange={toggle} />
                  {''}
                  <label className='px-5'>
                    Saya setuju dengan
                    <span style={{ color: '#FF6C06' }} onClick={toggle}>
                      {' '}
                      Syarat & Ketentuan{' '}
                    </span>{' '}
                    yang diberikan oleh Lembaga Pengelola Dana Pendidikan Kementrian Keuangan
                  </label>
                </div>

                <div className='space-between mb-30'>
                  <Link to={'/auth'} className='color-orange fontweight-600'>
                    Login?
                  </Link>
                </div>

                <button className='button mb-5' disabled={formik.isSubmitting || !formik.isValid}>
                  {loading ? 'Loading ...' : 'Aktivasi'}
                </button>

                <p className='text-center fontsize-14 color-grey mt-20' style={{ maxWidth: '500px' }}>
                  Tidak ada bagian dari situs web ini atau isinya yang boleh direproduksi, disalin,
                  dimodifikasi atau diadaptasi, tanpa persetujuan tertulis sebelumnya dari LPDP.
                </p>
              </form>
            </div>
          </div>
        </div>
      </Fragment>
    </Fragment>
  )
}
